import type { WorldEnemyType } from '@/types/enemy';
import type { WorldId } from '@/config/worlds';

export interface EnemyDefinition {
  type: WorldEnemyType;
  name: string;
  description: string;
  icon: string; // PixelIcon name
  accentColor: string;
}

export const ENEMY_DEFINITIONS: Record<WorldEnemyType, EnemyDefinition> = {
  bramble_beetle: {
    type: 'bramble_beetle',
    name: 'Bramble Beetle',
    description: 'Patrols back and forth. Predictable but blocks your path.',
    icon: 'enemyBeetle',
    accentColor: '#6abf69',
  },
  tunnel_drone: {
    type: 'tunnel_drone',
    name: 'Tunnel Drone',
    description: 'Stalks where you just were. Always one step behind.',
    icon: 'enemyDrone',
    accentColor: '#a0937d',
  },
  skid_mite: {
    type: 'skid_mite',
    name: 'Skid Mite',
    description: 'Bounces in random directions. Chaotic and hard to predict.',
    icon: 'enemyMite',
    accentColor: '#7ec8e3',
  },
  cinder_hound: {
    type: 'cinder_hound',
    name: 'Cinder Hound',
    description: 'Chases you directly. Fast and dangerous.',
    icon: 'enemyHound',
    accentColor: '#e05c3a',
  },
  echo_mirror: {
    type: 'echo_mirror',
    name: 'Echo Mirror',
    description: 'Copies your exact movement. Think before you move.',
    icon: 'enemyMirror',
    accentColor: '#c084fc',
  },
};

export const WORLD_ENEMY_MAP: Record<WorldId, WorldEnemyType> = {
  greenwood: 'bramble_beetle',
  stonehollow: 'tunnel_drone',
  frostline: 'skid_mite',
  emberdeep: 'cinder_hound',
  arcana: 'echo_mirror',
};

export const ENEMY_START_OFFSET = 5;

export function getMaxEnemies(levelIndexInWorld: number): number {
  if (levelIndexInWorld < 5) return 0;
  if (levelIndexInWorld < 8) return 1;
  if (levelIndexInWorld < 11) return 2;
  return 3;
}
